import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pb-6 md:pb-10 bg-cream relative overflow-hidden" data-id="element-32">
      {/* Product title */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center py-8 md:py-12 px-4" data-id="element-33">
        <h2 className="text-4xl md:text-6xl font-serif font-bold text-charcoal tracking-tight mb-3" data-id="element-34">
          CADENAS ROTAS
        </h2>
        <div className="w-16 h-0.5 bg-gold mx-auto mb-4" data-id="element-35"></div>
        <p className="text-sm md:text-base text-charcoal-light max-w-xl mx-auto leading-relaxed italic font-serif" data-id="element-36">
          El Manual para Sanar las Ataduras de tu Historia y Reclamar tu
          Bendición Familiar
        </p>
      </motion.div>

      {/* Full-width hero image */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="w-full mb-12 md:mb-16" data-id="element-37">
        <img src="https://cdn.magicpatterns.com/uploads/6pT8v4smEDssSgnRZYLMdi/mockup_hero.png" alt="Cadenas Rotas - Manual de sanación espiritual" className="w-full h-auto object-cover" data-id="element-38" />
      </motion.div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20" data-id="element-39">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full border border-gold/40" data-id="element-40"></div>
        <div className="absolute top-20 -left-20 w-64 h-64 rounded-full border border-gold/30" data-id="element-41"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10 px-4" data-id="element-42">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-3xl md:text-5xl lg:text-6xl font-serif text-charcoal font-bold leading-tight mb-6" data-id="element-43">
          ¿Y si el motivo por el que no puedes avanzar{' '}
          <span className="text-gold-dark italic" data-id="element-44">no es tuyo...</span> sino de
          alguien que vivió antes de que nacieras?
        </motion.h1>

        {/* Decorative sparkle divider */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={{
        opacity: 1,
        scaleX: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex items-center justify-center gap-3 mb-10" data-id="element-45">
          <div className="h-px w-16 bg-gold/40" data-id="element-46"></div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="text-gold" data-id="element-47">
            <path d="M10 0L10.9 7.5L18 10L10.9 12.5L10 20L9.1 12.5L2 10L9.1 7.5L10 0Z" fill="currentColor" opacity="0.6" data-id="element-48" />
          </svg>
          <div className="h-px w-16 bg-gold/40" data-id="element-49"></div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-charcoal-light mb-10 mx-auto leading-relaxed" data-id="element-50">
          Descubre el método de 7 días para identificar y cortar las ataduras
          invisibles que frenan tu abundancia, tus relaciones y tu paz interior.
        </motion.h2>

        {/* 3D Book image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.35
      }} className="mb-10" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/cCJY9PoULZBtJiYKEjV76U/Libro_3d.png" alt="Cadenas Rotas - Libro" className="w-64 md:w-80 mx-auto drop-shadow-2xl" data-id="element-52" />
        </motion.div>

        {/* Pulsing CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.45
      }} className="mb-12" data-id="element-53">
          <CTAButton pulse data-id="element-54" />
          <p className="mt-4 text-sm text-charcoal-light flex items-center justify-center gap-2" data-id="element-55">
            <span className="inline-block w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-56"></span>
            Acceso inmediato. Descarga digital.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="bg-white p-6 md:p-8 rounded-sm shadow-sm border border-gold/20 mb-12 text-center max-w-3xl mx-auto" data-id="element-57">
          <p className="text-charcoal mb-4 leading-relaxed" data-id="element-58">
            <strong className="font-serif text-xl" data-id="element-59">
              Oras. Trabajas. Decretas.
            </strong>{' '}
            Y aun así... sientes que hay algo que no te deja despegar del todo.
            No es falta de fe. No es falta de esfuerzo. Es algo más profundo,
            más antiguo y más silencioso que tú.
          </p>
          <p className="text-charcoal leading-relaxed" data-id="element-60">
            Seguro lo has sentido: esa sensación de llegar casi al éxito para
            que algo lo arruine. No es coincidencia.{' '}
            <span className="font-semibold text-gold-dark" data-id="element-61">
              Es una herencia espiritual que estás cargando sin saberlo.
            </span>
          </p>
        </motion.div>

        {/* Product mockup image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mt-4" data-id="element-62">
          <img src="https://cdn.magicpatterns.com/uploads/bdBPw1asfiVN3WXyHKVRd1/mockup1.png" alt="Cadenas Rotas - Disponible en todos tus dispositivos" className="w-full max-w-3xl mx-auto drop-shadow-xl" data-id="element-63" />
        </motion.div>
      </div>
    </section>;
}